import { fetchStore, fetchStoreByTerm } from "@/api/api-queries";
import { AppContext } from "@/pages/_app";
import classNames from "classnames";
import { useContext, useEffect, useRef } from "react";
import { CiSearch } from "react-icons/ci";

export default function SearchBar({
  isSearchBarOpen,
  setIsSearchBarOpen,
  btnType,
  setBtnType,
  domain,
  countryCode
}) {
  const inp = useRef();
  const { translation } = useContext(AppContext);
  
  const onSubmit = async (e) => {
    e.preventDefault();
    setIsSearchBarOpen(false);
    setTimeout(() => {
      setBtnType("button");
    }, 100);
    if (inp.current.value) {
        console.log(countryCode);
        console.log(inp.current.value);
      const newStore = await fetchStoreByTerm(countryCode, domain , inp.current.value);
      if (newStore) {
        window.location.href = `https://${newStore.subdomain
          .trim()
          .replaceAll(" ", "-")
          .toLowerCase()}.${domain}`;
      } else {
        window.location.href = `https://www.${domain}`;
      }
    }
  };

  const mobileSearch = () => {
    setIsSearchBarOpen(true);
    setTimeout(() => {
      setBtnType("submit");
    }, 100);
  };

  useEffect(() => {
    if (window.innerWidth > 768) {
      setBtnType("submit");
    }
  }, []);

  const inpClass = classNames({
    "!block": isSearchBarOpen,
  });


  return (
    <form
      onSubmit={onSubmit}
      className={
        "md:border md:border-primary md:w-auto rounded-full p-1 flex " +
        (isSearchBarOpen && "bg-white w-5/6")
      }
    >
      <input
        ref={inp}
        className={
          "bg-transparent hidden md:block md:w-56 w-full outline-none py-1 px-4 text-sm " +
          inpClass
        }
        type="text"
        placeholder={translation?.search}
      />
      <button
        onClick={mobileSearch}
        type={btnType}
        title="search"
        className="bg-primary h-auto py-1 md:py-0 text-white text-2xl w-14 rounded-full"
      >
        <CiSearch className="mx-auto" />
      </button>
    </form>
  );
}
